import { ProjectImpactContribution } from '@captaincause/ui/ProjectImpact/ContributionImpact'
import { ProjectOrganizationLogo } from '@captaincause/ui/ProjectOrganizationLogo'
import type { Campaign, Dift, Locales, Project } from '@captaincause/types'

interface HeaderProps {
  campaign?: Campaign
  dift?: Dift
  project: Project
  locale: Locales
}

export function Header({
  campaign = undefined,
  dift = undefined,
  project,
  locale,
}: HeaderProps) {
  const amount = campaign?.displayed_amount || dift?.amount

  return (
    <div className="flex items-start justify-between md:items-center">
      <div className="flex w-full flex-col px-4 md:px-0">
        <h2 className="mb-3 text-left font-default text-2xl font-semibold leading-8 text-black">
          {project.name}
        </h2>
        <ProjectOrganizationLogo project={project} className="md:hidden" />

        <ProjectImpactContribution
          locale={locale}
          project={project}
          className="hidden md:flex"
          contributedAmount={amount}
          pointsMode={campaign?.points_mode}
          pointsValueInCents={campaign?.points_value_in_cents}
        />
      </div>
    </div>
  )
}
